import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UnregisterSw, RegisterSw } from "./RegisterSw";

UnregisterSw();

ReactDOM.render(
	<BrowserRouter><App/></BrowserRouter>, 
	document.getElementById('app_page')
);